import { PaginatedDataStore } from '../../../ng-services/paginated-data.store';

export abstract class BaseExpandableTableComponent<T, F> {
    activeRows: number[] = [];

    get data() {
        return this.store.data;
    }

    constructor(protected store: PaginatedDataStore<T, F>) {}

    toggle(id: number) {
        if (this.activeRows.includes(id)) {
            this.activeRows = this.activeRows.filter((v) => v !== id);
            return;
        }

        this.activeRows.push(id);
    }

    isCollapsed(id: number) {
        return !this.activeRows.includes(id);
    }

    get isEmpty() {
        return this.store.isEmpty;
    }
}
